"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomWeightedElementV2 = exports.randomWeightedElement = exports.randomElements = exports.randomElement = exports.randomPercentTo = exports.randomPercent = exports.randomFloat = exports.random = void 0;
const Round_1 = require("../core/utils/Round");
/**
 * Generate a random int.
 * @param min inclusive min
 * @param max inclusive max
 * @returns A random number between min/max, inclusive
 */
const random = (min, max) => {
    const roll = Math.random();
    const diff = 1 + max - min;
    return Math.floor(roll * diff) + min;
};
exports.random = random;
const randomFloat = (min, max) => {
    const roll = Math.random();
    const diff = 1 + max - min;
    return roll * diff + min;
};
exports.randomFloat = randomFloat;
const randomPercent = () => {
    return (0, exports.random)(1, 100);
};
exports.randomPercent = randomPercent;
const randomPercentTo = (decimals = 2) => {
    return (0, Round_1.roundTo)((0, exports.random)(1, 10 ** (2 + decimals)) / 10 ** decimals, decimals);
};
exports.randomPercentTo = randomPercentTo;
const randomElement = (array) => {
    const next = Math.floor(Math.random() * array.length);
    return array[next];
};
exports.randomElement = randomElement;
const randomElements = (array, count, allowDuplicates = false) => {
    if (count === array.length) {
        return array;
    }
    if (allowDuplicates) {
        return Array(count).fill(0).map(() => (0, exports.randomElement)(array));
    }
    count = Math.min(array.length, count);
    let selected = new Set();
    while (selected.size < count) {
        let next = Math.floor(Math.random() * array.length);
        while (selected.has(next)) {
            next = Math.floor(Math.random() * array.length);
        }
        selected.add(next);
    }
    return Array.from(selected).map(i => array[i]);
};
exports.randomElements = randomElements;
const randomWeightedElement = (options) => {
    if (options.length === 0) {
        return undefined;
    }
    let totalWeights = 0;
    for (const option of options) {
        totalWeights += option.weight;
    }
    // option[0] =  20 (  0 + 20)
    // option[1] =  50 ( 20 + 30)
    // option[2] = 100 ( 50 + 50)
    // option[3] = 180 (100 + 80)
    // random(1, 130)
    // option[0] <=  20
    // option[1] <=  50
    // option[2] <= 100
    // option[3] <= 180
    // multiply by 100 to allow up to 3 decimals of precision
    const roll = (0, exports.random)(1, totalWeights * 1000);
    let sum = 0;
    for (const option of options) {
        sum += Math.floor(option.weight * 1000);
        if (roll <= sum) {
            return option.value;
        }
    }
    return options[0].value;
};
exports.randomWeightedElement = randomWeightedElement;
const randomWeightedElementV2 = (options) => {
    if (options.length === 0) {
        return undefined;
    }
    const totalWeights = options.reduce((sum, next) => sum + next.weight, 0);
    // option[0] =  20 (  0 + 20)
    // option[1] =  50 ( 20 + 30)
    // option[2] = 100 ( 50 + 50)
    // option[3] = 180 (100 + 80)
    // random(1, 130)
    // option[0] <=  20
    // option[1] <=  50
    // option[2] <= 100
    // option[3] <= 180
    // multiply by 100 to allow up to 3 decimals of precision
    const roll = (0, exports.random)(1, totalWeights * 1000);
    let sum = 0;
    for (const option of options) {
        sum += Math.floor(option.weight * 1000);
        if (roll <= sum) {
            return option;
        }
    }
    return options[0];
};
exports.randomWeightedElementV2 = randomWeightedElementV2;
